import React from 'react';
import { motion } from 'framer-motion';
import { FOOTER_LINKS, COMPANY_INFO } from '../../utils/constants';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';
import LogoText from '../LogoText';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleClick = (href) => {
    if (href === '#') return;
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-neutral-900 text-neutral-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Brand & Address */}
          <motion.div variants={staggerItem}>
            <div className="mb-4 flex items-center" style={{ marginTop: '-4px' }}>
              <LogoText className="font-bold text-2xl text-white" showInc />
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed mb-8" style={{ fontFamily: "'Livvic', sans-serif" }}>
              {COMPANY_INFO.tagline}
            </p>
            <div className="text-neutral-300 text-sm leading-relaxed space-y-1" style={{ fontFamily: "'Livvic', sans-serif" }}>
              <p className="text-white font-semibold">Office Address</p>
              <p>64 Babcock Crescent</p>
              <p>Milton</p>
              <p>ON L9T 5R5</p>
              <div className="pt-4 space-y-1">
                <p className="text-white font-semibold">Warehouse Address</p>
                <p>Mississauga, Ontario</p>
              </div>
              <div className="pt-4 space-y-1">
                <p>Customer Service: <a href="tel:+19053910648" className="hover:text-brand-400 transition-colors">1.905.391.0648</a></p>
                <p>Email: <a href="mailto:info@instruvia.ca" className="hover:text-brand-400 transition-colors">info@instruvia.ca</a></p>
              </div>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div variants={staggerItem}>
            <h3 className="text-white mb-4 h-7 flex items-center leading-tight" style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}>Quick Links</h3>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((link, i) => (
                <li key={i}>
                  <button
                    onClick={() => handleClick(link.href)}
                    className="text-neutral-400 hover:text-brand-400 transition-colors text-sm"
                    style={{ fontFamily: "'Livvic', sans-serif" }}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact */}
          <motion.div variants={staggerItem}>
            <h3 className="text-white mb-4 h-7 flex items-center leading-tight" style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}>Get in Touch</h3>
            <p className="text-neutral-400 text-sm mb-4" style={{ fontFamily: "'Livvic', sans-serif" }}>
              Have questions about equipment sourcing or partnerships? We'd love to hear from you.
            </p>
            <button
              onClick={() => handleClick('#contact')}
              className="bg-brand-500 text-white px-5 py-2 rounded-lg text-sm font-medium hover:bg-brand-600 transition-colors"
            >
              Contact Us
            </button>
          </motion.div>
        </motion.div>

        {/* Bottom Bar */}
        <motion.div
          className="border-t border-neutral-800 mt-12 pt-8"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p className="text-neutral-500 text-sm text-center" style={{ fontFamily: "'Livvic', sans-serif" }}>
            &copy; {currentYear} {COMPANY_INFO.copyright}
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;